import AnimatedListLine from './AnimatedListLine';

export default AnimatedListLine;



// WEBPACK FOOTER //
// ./scripts/elements/AnimatedListLine/index.js